import script from "./PersonAcountingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonAcountingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonAcountingComponent.vue?vue&type=style&index=0&id=41861402&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41861402"]])

export default __exports__